import React, { Component } from "react";
import {
  StyledVerticalSeparater,
  StyledTooltipWithKBDShortcut,
} from "../_components/styled/details/styleArtBoardEditor";
import {
  Button,
  ButtonGroup,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  Tooltip,
  MenuItemOption,
  Flex,
} from "@chakra-ui/react";
import {
  FaExpand,
  FaHandRock,
  FaMousePointer,
  FaSearchMinus,
  FaSearchPlus,
} from "react-icons/fa";
import { withTranslation } from "react-i18next";

class ArtBoardsRightFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      interactionMode: "selection",
    };
  }

  zoomDropdownOptions = [
    {
      label: "300%",
      value: 300,
    },
    {
      label: "200%",
      value: 200,
    },
    {
      label: "100%",
      value: 100,
    },
    {
      label: "75%",
      value: 75,
    },
    {
      label: "65%",
      value: 65,
    },
    {
      label: "50%",
      value: 50,
    },
    {
      label: "25%",
      value: 25,
    },
    {
      label: "10%",
      value: 10,
    },
    {
      label: "Fit",
      value: "fit",
    },
  ];

  handlers = {
    selectionMode: () => {
      if (this.props.canvasRef.handler.interactionHandler.isDrawingMode()) {
        return;
      }
      this.forceUpdate();
      this.props.canvasRef.handler.interactionHandler.selection();
      this.setState({ interactionMode: "selection" });
    },
    grabMode: () => {
      if (this.props.canvasRef.handler.interactionHandler.isDrawingMode()) {
        return;
      }
      this.forceUpdate();
      this.props.canvasRef.handler.interactionHandler.grab();
      this.setState({ interactionMode: "grab" });
    },
  };

  onClickZoomOption = (zoomVal) => {
    const { canvasRef } = this.props;
    if (zoomVal === "fit") {
      canvasRef.handler.zoomHandler.zoomOneToOne();
    } else {
      canvasRef.handler.zoomHandler.zoomToPercentage(zoomVal);
    }
  };

  render() {
    const { interactionMode } = this.state;
    const { canvasRef, zoomRatio, t } = this.props;
    const { selectionMode, grabMode } = this.handlers;
    if (!canvasRef) {
      return null;
    }
    const zoomValue = parseInt((zoomRatio * 100).toFixed(2), 10);
    return (
      <Flex my="auto" grow={1} direction="row-reverse" data-click>
        <div className="tldr-editor-rfooter-toolbar">
          <Tooltip hasArrow placement="top" label={t("selection")}>
            <IconButton
              icon={<FaMousePointer />}
              size="sm"
              variant="ghost"
              type={(interactionMode === "selection").toString()}
              onClick={() => {
                selectionMode();
              }}
              color={
                interactionMode === "selection" ? "primary.200" : "gray.100"
              }
            />
          </Tooltip>
          <Tooltip
            hasArrow
            placement="top"
            label={
              <StyledTooltipWithKBDShortcut>
                {t("grab_artboard_btn")}
                <div className="hotkeys">
                  <kbd>{t("space")}</kbd> & <kbd>{t("drag")}</kbd>
                </div>
              </StyledTooltipWithKBDShortcut>
            }
          >
            <IconButton
              icon={<FaHandRock />}
              size="sm"
              variant="ghost"
              type={(interactionMode === "grab").toString()}
              onClick={() => {
                grabMode();
              }}
              color={interactionMode === "grab" ? "primary.200" : "gray.100"}
            />
          </Tooltip>
          <StyledVerticalSeparater />
          <ButtonGroup isAttached>
            <Tooltip
              placement="top"
              hasArrow
              label={
                <StyledTooltipWithKBDShortcut>
                  {t("zoom_out")}
                  <div className="hotkeys">
                    <kbd>-</kbd>
                  </div>
                </StyledTooltipWithKBDShortcut>
              }
            >
              <IconButton
                icon={<FaSearchMinus />}
                size="sm"
                variant="ghost"
                onClick={() => {
                  canvasRef.handler.zoomHandler.zoomOut();
                }}
              />
            </Tooltip>

            <Menu placement="top-end" isLazy>
              <Tooltip hasArrow placement="top" label={t("zoom_percentage")}>
                <MenuButton as={Button} variant="ghost" size="sm">
                  {`${zoomValue}%`}
                </MenuButton>
              </Tooltip>
              <MenuList minW="100px">
                <MenuOptionGroup type="radio">
                  {this.zoomDropdownOptions.map((zoomItem) => (
                    <MenuItemOption
                      key={zoomItem.value}
                      value={zoomItem.label}
                      onClick={() => {
                        this.onClickZoomOption(zoomItem.value);
                      }}
                    >
                      {zoomItem.label}
                    </MenuItemOption>
                  ))}
                </MenuOptionGroup>
              </MenuList>
            </Menu>

            <Tooltip
              placement="top"
              hasArrow
              label={
                <StyledTooltipWithKBDShortcut>
                  {t("zoom_in")}
                  <div className="hotkeys">
                    <kbd>+</kbd>
                  </div>
                </StyledTooltipWithKBDShortcut>
              }
            >
              <IconButton
                icon={<FaSearchPlus />}
                size="sm"
                variant="ghost"
                onClick={() => {
                  canvasRef.handler.zoomHandler.zoomIn();
                }}
              />
            </Tooltip>
          </ButtonGroup>
          <StyledVerticalSeparater />

          <Tooltip
            hasArrow
            placement="top"
            label={
              <StyledTooltipWithKBDShortcut>
                {t("fit")}
                <div className="hotkeys">
                  <kbd>P</kbd>
                </div>
              </StyledTooltipWithKBDShortcut>
            }
          >
            <IconButton
              icon={<FaExpand />}
              size="sm"
              variant="ghost"
              onClick={() => {
                canvasRef.handler.zoomHandler.zoomToFit();
              }}
            />
          </Tooltip>
        </div>
      </Flex>
    );
  }

  componentDidMount() {}
}

ArtBoardsRightFooter.propTypes = {};

export default withTranslation(["studio"])(ArtBoardsRightFooter);
